import { Card, Heading } from "@chakra-ui/react";
import ContactMe from "../../../../components/contact-me/ContactMe";

export default function GetInTouch() {
  return (
    <Card
      variant={"custom"}
      width={{ base: "100%", md: "75%" }}
      justifyContent={"space-around"}
      direction={{ base: "column", md: "row" }}
    >
      <Heading size={"lg"}>Got a new idea? Let's bring it to life</Heading>
      <ContactMe />
    </Card>
  );
}
